(function () {
  var filterLabels = {
    'custom.riding_style': 'Fahrstil',
    'custom.was_ist_ihnen_am_wichtigsten': 'Prioritäten',
    'custom.frame_type': 'Rahmentyp',
    'custom.drivetrain': 'Antrieb',
    'custom.motor': 'Motor',
    'custom.reichweite': 'Reichweite',
    'custom.rider_height_filter': 'Fahrergröße'
  };

  var filterAliases = {
    'custom.what_matters_most': 'custom.was_ist_ihnen_am_wichtigsten',
    'custom.what_priorities': 'custom.was_ist_ihnen_am_wichtigsten',
    'custom.custom_range_filter': 'custom.reichweite',
    'custom.range_filter': 'custom.reichweite',
    'custom.range': 'custom.reichweite',
    'custom.rider_height': 'custom.rider_height_filter'
  };

  var compareStorageKey = 'hitway-eu-compare-products';
  var compareLimit = 4;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function filterKey(element) {
    var source = element.id || '';
    var input = element.querySelector('input[name*="filter.p.m.custom"]');
    if (input) source += ' ' + input.name;

    var exactKey = Object.keys(filterLabels).find(function (key) {
      return source.indexOf(key) !== -1;
    });
    if (exactKey) return exactKey;

    var aliasKey = Object.keys(filterAliases).find(function (key) {
      return source.indexOf(key) !== -1;
    });
    if (aliasKey) return filterAliases[aliasKey];

    var label = element.querySelector('.facets__summary-label, .mobile-facets__summary .f-w-600');
    var normalizedLabel = normalize(label ? label.textContent.replace(/\(\d+\)/g, '') : '');
    return Object.keys(filterLabels).find(function (key) {
      return normalizedLabel.indexOf(normalize(filterLabels[key])) === 0;
    });
  }

  function loadCompareSelection() {
    try {
      var selection = JSON.parse(window.sessionStorage.getItem(compareStorageKey) || '[]');
      return Array.isArray(selection) ? selection.filter(function (item) {
        return item && item.handle && item.title;
      }).slice(0, compareLimit) : [];
    } catch (error) {
      return [];
    }
  }

  function saveCompareSelection(selection) {
    try {
      window.sessionStorage.setItem(compareStorageKey, JSON.stringify(selection));
    } catch (error) {
      // Comparison still works for the current page when storage is unavailable.
    }
  }

  function compareItem(input) {
    return {
      handle: input.value,
      title: input.getAttribute('data-product-title') || input.value,
      url: input.getAttribute('data-product-url') || '',
      image: input.getAttribute('data-product-image') || ''
    };
  }

  function syncCompareInputs(root, selection) {
    var selectedHandles = selection.map(function (item) { return item.handle; });
    root.querySelectorAll('[data-hitway-compare-product]').forEach(function (input) {
      input.checked = selectedHandles.indexOf(input.value) !== -1;
      input.disabled = selection.length >= compareLimit && !input.checked;
    });
  }

  function compareUrl(root, selection) {
    var url = new URL(root.getAttribute('data-compare-url') || '/pages/compare-hitway-ebikes', window.location.origin);
    url.searchParams.set('products', selection.map(function (item) { return item.handle; }).join(','));
    return url.pathname + url.search + url.hash;
  }

  function renderCompare(root, selection) {
    var dock = root.querySelector('[data-hitway-compare-dock]');
    if (!dock) return;

    var list = dock.querySelector('[data-hitway-compare-list]');
    var count = dock.querySelector('[data-hitway-compare-count]');
    var status = dock.querySelector('[data-hitway-compare-status]');
    var link = dock.querySelector('[data-hitway-compare-link]');
    dock.hidden = selection.length === 0;
    if (count) count.textContent = selection.length;

    if (list) {
      list.textContent = '';
      selection.forEach(function (item) {
        var chip = document.createElement('span');
        chip.className = 'hitway-compare-dock__chip';

        if (item.image) {
          var image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 40;
          image.height = 40;
          chip.appendChild(image);
        }

        var title = document.createElement('span');
        title.textContent = item.title;
        chip.appendChild(title);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('data-hitway-compare-remove', item.handle);
        remove.setAttribute('aria-label', item.title + ' entfernen');
        remove.textContent = '\u00d7';
        chip.appendChild(remove);
        list.appendChild(chip);
      });
    }

    var ready = selection.length >= 2;
    if (status) status.textContent = ready ? 'Bereit zum Vergleichen' : 'Wählen Sie ein weiteres E-Bike';
    if (link) {
      link.href = compareUrl(root, selection);
      link.setAttribute('aria-disabled', ready ? 'false' : 'true');
      link.classList.toggle('is-disabled', !ready);
    }

    syncCompareInputs(root, selection);
  }

  function initializeCompare(root) {
    var selection = loadCompareSelection();
    renderCompare(root, selection);

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-hitway-compare-product]');
      if (!input) return;

      selection = selection.filter(function (item) { return item.handle !== input.value; });
      if (input.checked && selection.length < compareLimit) selection.push(compareItem(input));
      saveCompareSelection(selection);
      renderCompare(root, selection);
    });

    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-hitway-compare-remove]');
      if (remove) {
        selection = selection.filter(function (item) {
          return item.handle !== remove.getAttribute('data-hitway-compare-remove');
        });
        saveCompareSelection(selection);
        renderCompare(root, selection);
        return;
      }

      if (event.target.closest('[data-hitway-compare-clear]')) {
        selection = [];
        saveCompareSelection(selection);
        renderCompare(root, selection);
        return;
      }

      var link = event.target.closest('[data-hitway-compare-link]');
      if (link && selection.length < 2) event.preventDefault();
    });

  }

  function frameImages(root) {
    var images = {};
    root.querySelectorAll('[data-frame-value][data-frame-image]').forEach(function (item) {
      var imageUrl = item.getAttribute('data-frame-image');
      var aliases = item.getAttribute('data-frame-aliases') || item.getAttribute('data-frame-value');
      aliases.split('|').forEach(function (alias) {
        images[normalize(alias)] = imageUrl;
      });
    });
    return images;
  }

  function frameImageForValue(images, value) {
    var key = normalize(value);
    if (images[key]) return images[key];

    var groups = [
      { imageKey: 'folding', terms: ['fold', 'falt', 'klapp'] },
      { imageKey: 'step-through', terms: ['step-through', 'stepthrough', 'low-step', 'lowstep', 'low-entry', 'open-frame', 'tiefeinsteiger', 'tief', 'durchstieg', 'wave'] },
      { imageKey: 'step-over', terms: ['step-over', 'stepover', 'high-step', 'highstep', 'high-entry', 'hoher-einstieg', 'diamond', 'diamant', 'crossbar'] },
      { imageKey: 'trapeze-frame', terms: ['trapez', 'trapezoid'] }
    ];

    for (var index = 0; index < groups.length; index += 1) {
      var group = groups[index];
      var matched = group.terms.some(function (term) { return key.indexOf(term) !== -1; });
      if (matched && images[group.imageKey]) return images[group.imageKey];
    }

    return '';
  }

  function setDesktopLabel(details, label) {
    var target = details.querySelector('.facets__summary-label');
    if (!target) return;
    var textNode = Array.prototype.find.call(target.childNodes, function (node) {
      return node.nodeType === 3;
    });
    var nextLabel = label + ' ';
    if (textNode && textNode.nodeValue !== nextLabel) textNode.nodeValue = nextLabel;
  }

  function setMobileLabel(details, label) {
    var target = details.querySelector('.mobile-facets__summary .f-w-600');
    if (target && target.textContent !== label) target.textContent = label;
  }

  function enhanceFrameOptions(details, images) {
    details.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input && label.htmlFor) {
        var linkedInput = document.getElementById(label.htmlFor);
        if (linkedInput && details.contains(linkedInput)) input = linkedInput;
      }
      if (!input || label.querySelector('.hitway-eu-frame-image')) return;
      var imageUrl = frameImageForValue(images, input.value);
      if (!imageUrl) return;

      var image = document.createElement('img');
      image.className = 'hitway-eu-frame-image';
      image.src = imageUrl;
      image.alt = input.value;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 240;
      image.height = 160;
      label.prepend(image);
    });
  }

  function updateMobileButton(root) {
    var label = root.querySelector('.mobile-facets__open-label.medium-hide');
    if (!label) return;
    var count = root.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked').length;
    var nextLabel = count ? 'Filtern & Sortieren (' + count + ')' : 'Filtern & Sortieren';
    if (label.textContent !== nextLabel) label.textContent = nextLabel;
  }

  function enhance(root) {
    var images = frameImages(root);

    root.querySelectorAll('.js-filter').forEach(function (details) {
      var key = filterKey(details);
      details.classList.toggle('hitway-eu-filter--allowed', Boolean(key));
      details.classList.toggle('hitway-eu-filter--frame', key === 'custom.frame_type');
      if (!key) return;
      setDesktopLabel(details, filterLabels[key]);
      setMobileLabel(details, filterLabels[key]);
      if (key === 'custom.frame_type') enhanceFrameOptions(details, images);
    });

    updateMobileButton(root);
    syncCompareInputs(root, loadCompareSelection());
  }

  function initialize(root) {
    if (root.getAttribute('data-hitway-eu-initialized') === 'true') {
      enhance(root);
      return;
    }
    root.setAttribute('data-hitway-eu-initialized', 'true');

    initializeCompare(root);
    enhance(root);

    root.addEventListener('change', function () {
      window.requestAnimationFrame(function () {
        updateMobileButton(root);
      });
    });

    if ('MutationObserver' in window) {
      var observerOptions = { childList: true, subtree: true };
      var observer = new MutationObserver(function (mutations) {
        var hasAddedElements = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1;
          });
        });

        if (!hasAddedElements) return;

        observer.disconnect();
        try {
          enhance(root);
        } finally {
          observer.observe(root, observerOptions);
        }
      });
      observer.observe(root, observerOptions);
    }
  }

  document.querySelectorAll('[data-hitway-eu-grid]').forEach(initialize);

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-hitway-eu-grid] .color-variant-product');
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (!card) return;
    var list = swatch.closest('ul');
    if (list) {
      list.querySelectorAll('li.selected').forEach(function (item) {
        item.classList.remove('selected');
      });
      if (swatch.parentElement) swatch.parentElement.classList.add('selected');
    }

    var imageUrl = swatch.getAttribute('data-variant-image');
    var variantUrl = swatch.getAttribute('data-variant-url');
    var image = card.querySelector('.product-image');
    if (image && imageUrl) image.src = imageUrl;
    if (variantUrl) {
      card.querySelectorAll('a[href]').forEach(function (link) {
        if (link.classList.contains('buy-now-btn')) link.href = variantUrl;
      });
    }
  });
})();

